var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.936,
    height: 68.458,
    viewBox: "0 0 56.936 68.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.058,
    y1: 0.085,
    x2: 1,
    y2: 0.957,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 56.936,
    height: 68.458,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M55.19,6.823a55.742,55.742,0,0,0-53.444,0A3.494,3.494,0,0,0,0,9.892V51.243a3.494,3.494,0,0,0,1.746,3.069L27.051,68.1a2.955,2.955,0,0,0,2.833,0L55.19,54.312a3.494,3.494,0,0,0,1.746-3.069V9.892A3.494,3.494,0,0,0,55.19,6.823M50.61,49.106,28.468,61.166,6.326,49.106V12.065a49.765,49.765,0,0,1,44.284,0Z",
    transform: "translate(0 0.001)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M12.067,21.6a3,3,0,0,0-4.133,1.131,3.639,3.639,0,0,0,.641,4.576L18.064,34.2a2.727,2.727,0,0,0,1.747.592,3.032,3.032,0,0,0,2.239-1.006l15.816-17.23a3.638,3.638,0,0,0,0-4.88,2.962,2.962,0,0,0-4.479,0L19.4,26.891Z",
    transform: "translate(5.494 9.564)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon4);
export default __webpack_public_path__ + "static/media/social_icon4.5a3fd31c98f2cc82a0ab3da7f32afb20.svg";
export { ForwardRef as ReactComponent };